import type { Icon } from "@phosphor-icons/react";

export type DialogHeaderLeftButton = {
  icon: Icon;
  onClick: () => void;
};

export const DialogHeader: React.FC<{
  children: string;
  leftButton?: DialogHeaderLeftButton;
}> = ({ children, leftButton }) => {
  const Icon = leftButton?.icon;
  return (
    <div
      data-dialog-header
      className="flex h-16 shrink-0 grid-cols-[1fr_auto_1fr] items-center justify-center border-b px-4 text-center title has-[button]:grid"
    >
      {Icon && (
        <button
          type="button"
          className="btn btn-square btn-ghost btn-sm"
          onClick={leftButton.onClick}
        >
          <Icon weight="bold" className="size-5" />
        </button>
      )}
      <h1 className="px-2">{children}</h1>
    </div>
  );
};
